'use client'
import { QuarterlySubmissionModule } from '@repo/hmrc-itsa/QuarterlySubmissionModule'

const ItsaMtdQuarterly = () => {
  return <QuarterlySubmissionModule />
}

export default ItsaMtdQuarterly
